import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.availableIntegrations`;
export const INIT = `${SCOPE}/INIT`;
export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
